import { useSearchParams } from "react-router-dom";
import { PageShell } from "../../ui";
import SentEmails from "./SentEmails";
import Campaigns from "./Campaigns";

/** Every email Brevo has sent for Inflos (superadmins only). `?q=` prefills
 * the search, so other pages can link to one person's emails. */
export default function Emails() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") === "campaigns" ? "campaigns" : "sent";

  return (
    <PageShell
      title="Emails"
      subtitle="What Brevo has sent: order and account emails, cart reminders, chat alerts and campaigns."
      tabs={{
        value: tab,
        onChange: (key) => setSearchParams(key === "campaigns" ? { tab: key } : {}, { replace: true }),
        items: [
          { value: "sent", label: "Sent emails" },
          { value: "campaigns", label: "Campaigns" },
        ],
      }}
    >
      {tab === "sent" ? <SentEmails initialQuery={searchParams.get("q") ?? ""} /> : <Campaigns />}
    </PageShell>
  );
}
